import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ASSETS } from '@env';
import { DashboardProvider } from '@providers/dashboard/dashboard'
import { LoadingProvider } from '@providers/loading/loading';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-detalle-ronda',
  templateUrl: 'detalle-ronda.html',
})
export class DetalleRondaPage {

  jugadorID: string;
  oponenteID: string;
  areaID: string;
  retoID: string;
  estadistica: any;
  AVATAR_PLAYER = ASSETS.AVATAR_PLAYER;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private dashboardProvider: DashboardProvider,
    private loadingProvider: LoadingProvider,
    private translateService: TranslateService,
  ) {
    this.jugadorID = navParams.get('jugadorID');
    this.oponenteID = navParams.get('oponenteID');
    this.areaID = navParams.get('areaID');
    this.retoID = navParams.get('retoID');
  }

  ionViewDidLoad() {
    if(this.retoID) {
      this.buscaPorIdRonda();
    } else {
      this.buscaRetoEnCurso();
    }
  }

  buscaPorIdRonda() {
    this.loadingProvider.show(true);
    this.dashboardProvider.detalleRonda(this.areaID, this.jugadorID, this.oponenteID, this.retoID)
      .then( estadistica => {
        this.estadistica = estadistica;
      })
      .then( _ => this.loadingProvider.show(false) )
      .catch( e => {
        console.log(e);
        this.loadingProvider.show(false);
      });
  }

  buscaRetoEnCurso() {
    this.loadingProvider.show(true);
    this.dashboardProvider.detalleRonda(this.areaID, this.jugadorID, this.oponenteID)
      .then( estadistica => {
        this.estadistica = estadistica;
      })
      .then( _ => this.loadingProvider.show(false) )
      .catch( e => {
        console.log(e);
        this.loadingProvider.show(false);
      });
  }

  generaIconoGanador(ronda, jugador) {
    if( !ronda.ganador ) return '';

    if( ronda.ganador == jugador ) return 'assets/imgs/checked.svg';

    return 'assets/imgs/cancel.svg';
  }

  calculaPreguntasCorrectas(ronda, jugador){
    let preguntas;
    if(ronda.jugador1 && ronda.jugador1.jugador == jugador) {
      preguntas = ronda.jugador1;
    } else if (ronda.jugador2 && ronda.jugador2.jugador == jugador){
      preguntas = ronda.jugador2;
    }

    return preguntas ? preguntas.totalCorrectas: '-';
  }

  calculaTiempo(ronda, jugador){
    let preguntas;
    if(ronda.jugador1 && ronda.jugador1.jugador == jugador) {
      preguntas = ronda.jugador1;
    } else if (ronda.jugador2 && ronda.jugador2.jugador == jugador){
      preguntas = ronda.jugador2;
    }

    if(!preguntas) return '-';

    let tiempo =  preguntas.estadisticas.filter( p => p.esCorrecta).reduce( (anterior, actual) => anterior += actual.tiempo, 0);
    return Math.round( tiempo * 100) / 100 + ' seg';
  }

  calculaEfectividad(ronda, jugador){
    let preguntas;
    if(ronda.jugador1 && ronda.jugador1.jugador == jugador) {
      preguntas = ronda.jugador1;
    } else if (ronda.jugador2 && ronda.jugador2.jugador == jugador){
      preguntas = ronda.jugador2;
    }

    if(!preguntas) return '-';


    let sumaCorrectas = preguntas.estadisticas.filter( p => p.esCorrecta).length;

    let efectividad = (sumaCorrectas * 100) / preguntas.estadisticas.length;

    return Math.round( efectividad * 100) / 100 + '%';
  }

  generaTextoHeader() {
    let ultimaRonda = this.estadistica.retoActual.rondas[this.estadistica.retoActual.rondas.length - 1]
    if(ultimaRonda.jugador1.jugador == this.jugadorID) {
      return this.translateService.instant('detalleRonda.status.await');
    }
    if(ultimaRonda.jugador1.jugador == this.oponenteID) {
      return this.translateService.instant('detalleRonda.status.awaitResponse');
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/detalle-ronda/detalle-ronda.ts